import MQTT from 'paho-mqtt';
import { getMe, getAuth } from 'service/local-data-provider';
import { config } from 'config';

const PORT = 8084;
const RECONNECT_INTERVAL_MILLISECOND = 10000;
const { broker } = config;

class MqttService {
  mqtt;

  onActionCallBack = mqttAction => {
    console.log(`MQTT onMessageArrived: ${mqttAction.action}`);
  };

  connect = () => {
    if (this.mqtt && this.mqtt.isConnected()) {
      this.disconnect();
    }
    const me = getMe();
    if (me) {
      const clientId = me.id;
      const password = getAuth().accessToken;
      this.mqtt = new MQTT.Client(broker, PORT, clientId);
      this.mqtt.connect({
        userName: 'USER',
        password,
        useSSL: true,
        onSuccess: this.onConnectSuccess,
        onFailure: this.onConnectFailure,
        cleanSession: false,
        mqttVersion: 4,
      });
      this.mqtt.onMessageArrived = this.onMessageArrived;
      this.mqtt.onConnectionLost = this.onConnectionLost;
    }
  };

  disconnect = () => {
    if (this.mqtt && this.mqtt.isConnected()) {
      this.mqtt.disconnect();
    }
  };

  onConnectSuccess = () => {
    const topic = `/user/v1/${getMe().id}`;
    this.mqtt.subscribe(topic);
  };
  onConnectFailure = error => {
    console.log(`MQTT onConnectFailure : ${error.errorMessage}`);
  };
  onMessageArrived = message => {
    const mqttAction = JSON.parse(message.payloadString);
    console.log(`MQTT onMessageArrived : ${mqttAction.action}`);
    this.onActionCallBack(mqttAction);
  };
  onConnectionLost = error => {
    if (error.errorCode !== 0) {
      console.log(`MQTT onConnectionLost : ${error.errorMessage}`);
      // 斷線後 10 秒後自動重連一次
      const id = setTimeout(() => {
        this.connect();
        clearInterval(id);
      }, RECONNECT_INTERVAL_MILLISECOND);
    }
  };
}

export default new MqttService();
